module.exports = __webpack_public_path__ + "Sumanthmuralikumar-26f08f69.png";